import produce from "immer";
import { IStoreState } from "..";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_GOODS_RECEIVED_NOTE_STATE,
  CLEAR_SINGLE_GOODS_RECEIVED_NOTE,
  defaultGoodsReceivedNoteState,
  FETCH_GOODS_RECEIVED_NOTE_LIST_FAILED,
  FETCH_GOODS_RECEIVED_NOTE_LIST_PROGRESS,
  FETCH_GOODS_RECEIVED_NOTE_LIST_SUCCESS,
  FETCH_SINGLE_GOODS_RECEIVED_NOTE_FAILED,
  FETCH_SINGLE_GOODS_RECEIVED_NOTE_PROGRESS,
  FETCH_SINGLE_GOODS_RECEIVED_NOTE_SUCCESS,
  GoodsReceivedNoteActions,
} from ".";

export const grnReducer = (
  state: IStoreState["grn"] = defaultGoodsReceivedNoteState,
  action: GoodsReceivedNoteActions,
) => {
  switch (action.type) {
    case FETCH_GOODS_RECEIVED_NOTE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.goods_received_note_list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_GOODS_RECEIVED_NOTE_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.goods_received_note_list.loading = LoadState.Loaded;
        draftState.goods_received_note_list.list = data;
        draftState.goods_received_note_list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_GOODS_RECEIVED_NOTE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.goods_received_note_list.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_SINGLE_GOODS_RECEIVED_NOTE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.single_goods_received_note.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SINGLE_GOODS_RECEIVED_NOTE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_goods_received_note.loading = LoadState.Loaded;
        draftState.single_goods_received_note.data = data;
      });
      return newState;
    }
    case FETCH_SINGLE_GOODS_RECEIVED_NOTE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_goods_received_note.loading = LoadState.Failed;
        draftState.single_goods_received_note.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_SINGLE_GOODS_RECEIVED_NOTE: {
      const newState = produce(state, (draftState) => {
        draftState.single_goods_received_note.loading = LoadState.NotLoaded;
        draftState.single_goods_received_note.data =
          defaultGoodsReceivedNoteState["single_goods_received_note"]["data"];
        draftState.single_goods_received_note.error =
          defaultGoodsReceivedNoteState["single_goods_received_note"]["error"];
      });
      return newState;
    }
    case CLEAR_GOODS_RECEIVED_NOTE_STATE: {
      return defaultGoodsReceivedNoteState;
    }

    default: {
      return state;
    }
  }
};
